import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OutingApprovalApiService {

  private token ="eyJhbGciOiJIUzUxMiJ9.eyJkZXZpY2VTZXNzaW9uSWQiOiI4eGFLbzhEZ2dBJTJCNEc4V0Rqc0pqV21FM3dPMmRicmE5b3I4ZVd5M1RpbVNMdTAlMkJIQ0V1QiUyRms4Q2VGcjIlMkZyYWoiLCJ0b2tlblJlZnJlc2hLZXkiOiIlMkZRJTJCUHlURFV3NmVveHZkMzM0UDYlMkJyRzViY2FRanl0Smc0Wk5NajJNamlwUmhPWSUyQmYxamx4RCUyRiUyQmtra3d6Y05sIiwiY2FtcHVzSWQiOjEwOCwicGF5cm9sbElkIjoiSFlEMTAzMTM1IiwidXNlck5hbWUiOiJDSCBTQVRZQU5BUkFZQU5BIiwidXNlcklkIjoiSFlEMTAzMTM1IiwidW5pcXVlSWQiOjI4NDg2LCJwbGF0Zm9ybSI6IlNDQUlUUyIsImp0aSI6Ijg3ODQ1OTU0LTA4MTgtNGE1Ni1hMWUxLTIyMzAxZGU1MjdmNSIsImlhdCI6MTc2OTc1MjY1NCwiZXhwIjoxNzY5ODM5MDU0fQ.3DBqCmGWxZBIJiF-Nctt73zf7ksGNItzGLgRgX55GEXJUDPpZH_vK6M0NCCYZSjV-aR8pBnigclqLEFtOlrRBg"

  private sumbitUrl = "https://testmasters.scaits.net/employee/api/jwtV2/studentOuting/approvedDetails"

  private employeeList = "/apiV2/common/campusEmpList?campusId="

  private qrDetails = "/employee/api/jwtV2/studentOuting/generateSingleQr?outingId="

  private approvedEmpId = "&approvedEmpId="

  private confirmedEmpId = "&confirmedEmpId="

  private requestDetails = "/employee/api/jwtV2/studentOuting/requestDetails?requestId="

  constructor(private http: HttpClient) { }

  getOutingRequests(payrollId: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });

    return this.http.get(environment.masterDomain+"/employee/api/jwtV2/studentOuting/requests?payrollId=UwmSTDnocaTvOuUWLcmbsqyL%2BYUBGjoQ%2FC%2BOQm4biKQ%3D", { headers });
  }

   getOutingRequestDetails(requestId: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(environment.masterDomain + this.requestDetails+requestId, { headers });
  }

  getEmployeeList(campusid: any) {

    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(environment.masterDomain + this.employeeList + campusid, { headers })


    return this.http.get("https://testmasters.scaits.net/employee/api/jwtV2/studentOuting/requests?payrollId=p5QGVg9adGwHOWhohvNtZ1V5wIEOgZyeJEIwkMnQ1d8%253D", { headers });

  }

  submitApproval(payload: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.post(this.sumbitUrl, payload, { headers })
  }
  getsectons(){
     const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get('')
  }
  getsectionwisestudent(section:any){
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
  return  this.http.get('https://testmasters.scaits.net/employee/api/jwtV2/outing/student/sectionStudents?sectionId='+ section,{headers})
  }
  getsection(){
     const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get('https://testmasters.scaits.net/apiV2/common/getEmpAllotedCampusSections',{headers})
  }
  getoutingReason(){
     const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get('https://testmasters.scaits.net/employee/api/jwtV2/outing/getOutingReasons',{headers})
  }
getgatepass(){
   const headers = new HttpHeaders({
      'Authorization': this.token,
    });
  return this.http.get('https://testmasters.scaits.net/employee/api/jwtV2/outing/student/approvedListForOutPass',{headers})
}

  getQrDetails(outingId: any) {
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get(environment.masterDomain + this.qrDetails + outingId, { headers ,responseType: 'blob'})
  }
  getbulkreqest(paylaod:any){

  }
}
